//#region src/documents.ts
/**
* Year keys used to index file result objects.
*/
let FileYear = /* @__PURE__ */ function(FileYear) {
	FileYear["current"] = "current";
	FileYear["previous"] = "previous";
	return FileYear;
}({});
/**
* Every reportable document category, in the order the dashboard renders them — the brochure that
* carries the enrollment form first, then its variants, then the per-policy and per-state
* documents.
*/
const documentCategories = [
	{
		key: "brochure",
		label: "Brochure",
		short: "Brochure",
		required: true
	},
	{
		key: "spanish",
		label: "Spanish brochure",
		short: "Spanish",
		required: false
	},
	{
		key: "athletic",
		label: "Athletic brochure",
		short: "Athletic",
		required: false
	},
	{
		key: "needlestick",
		label: "Needlestick brochure",
		short: "Needlestick",
		required: false
	},
	{
		key: "summary",
		label: "Summary brochure",
		short: "Summary",
		required: false
	},
	{
		key: "uil",
		label: "UIL brochure",
		short: "UIL",
		required: false
	},
	{
		key: "pid",
		label: "Policy ID",
		short: "Policy ID",
		required: false
	},
	{
		key: "certificates",
		label: "Certificate",
		short: "Certificate",
		required: false
	},
	{
		key: "notice",
		label: "State notice",
		short: "Notice",
		required: false
	}
];
/**
* The document categories a school is expected to have, judged by what it actually had last year.
*
* Not every school carries every document by design — plan mix, state and school type all vary — so
* there is no fixed required set to measure against. Last year's uploads are the only evidence in
* the data of what this particular school is supposed to publish, which makes them the honest
* baseline. This is the same "had one last year" scoping the policy-gap list uses.
*
* @param previous - The school's previous-year file lists.
* @returns Categories the school published last year.
*/
function expectedCategories(previous) {
	return documentCategories.filter((c) => previous[c.key].length > 0).map((c) => c.key);
}
/**
* The categories a school published last year and has not published this year — a document that
* genuinely went missing at rollover, rather than one it never had.
*
* @param current - The school's active-year file lists.
* @param previous - The school's previous-year file lists.
* @returns Categories present last year and absent this year.
*/
function missingCategories(current, previous) {
	return documentCategories.filter((c) => previous[c.key].length > 0 && current[c.key].length === 0).map((c) => c.key);
}
//#endregion
export { FileYear, documentCategories, expectedCategories, missingCategories };

//# sourceMappingURL=documents.mjs.map